<template>
    <div>
        <form-row title="Buyer 1 Name">
            <input-text
                class="w-full"
                name="contacts[buyer_1][name]"
                :value="buyer_1.name"
                placeholder="Name"
                :read_only="read_only"
            />
        </form-row>

        <form-row title="Buyer 2 Name">
            <input-text
                class="w-full"
                name="contacts[buyer_2][name]"
                :value="buyer_2.name"
                placeholder="Name"
                :read_only="read_only"
            />
        </form-row>
    </div>
</template>

<script>
export default {
    props: {
        contacts: {},
        read_only: { default: false },
    },

    data() {
        return {
            buyer_1: this.contacts.buyer_1 || {},
            buyer_2: this.contacts.buyer_2 || {},
        }
    },
}
</script>
